import { ElForm, ElInput, NamePath } from '@qsxy/element-plus-react';
import React, { memo } from 'react';

interface Props {
	/** label 标签的文本 */
	label?: boolean | string | React.ReactElement;
	/** 表单名称 */
	name: NamePath;
}

/** 隐藏类型表单组件 */
const HiddenFormItem = (props: Props) => {
	const { label, name } = props;
	return (
		<ElForm.Item label={label} name={name} noStyle>
			<ElInput type="hidden" style={{ display: 'none' }} />
		</ElForm.Item>
	);
};

export default memo(HiddenFormItem);
